// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booster-open-enter-active.card {
	--intro-duration: 0.5s;
	--translation-duration: 0.5s;
	--flip-duration: 0.4s;
	--enter-delay-interval: 0.04s;

	--animation-index: 20;
	--enter-delay: calc((var(--animation-index) - 1) * var(--enter-delay-interval));

	animation:
		booster-card-enter-together var(--intro-duration) ease 0s 1,
		booster-card-enter var(--translation-duration) cubic-bezier(0.34, 0, 0.3, 1)
			calc(var(--intro-duration) + var(--enter-delay)) 1;
	animation-fill-mode: forwards, forwards;
	transform-origin: center 140%;
}

.booster-open-enter-active.card:nth-of-type(1) {
	--animation-index: 1;
}
.booster-open-enter-active.card:nth-of-type(2) {
	--animation-index: 2;
}
.booster-open-enter-active.card:nth-of-type(3) {
	--animation-index: 3;
}
.booster-open-enter-active.card:nth-of-type(4) {
	--animation-index: 4;
}
.booster-open-enter-active.card:nth-of-type(5) {
	--animation-index: 5;
}
.booster-open-enter-active.card:nth-of-type(6) {
	--animation-index: 6;
}
.booster-open-enter-active.card:nth-of-type(7) {
	--animation-index: 7;
}
.booster-open-enter-active.card:nth-of-type(8) {
	--animation-index: 8;
}
.booster-open-enter-active.card:nth-of-type(9) {
	--animation-index: 9;
}
.booster-open-enter-active.card:nth-of-type(10) {
	--animation-index: 10;
}
.booster-open-enter-active.card:nth-of-type(11) {
	--animation-index: 11;
}
.booster-open-enter-active.card:nth-of-type(12) {
	--animation-index: 12;
}
.booster-open-enter-active.card:nth-of-type(13) {
	--animation-index: 13;
}
.booster-open-enter-active.card:nth-of-type(14) {
	--animation-index: 14;
}
.booster-open-enter-active.card:nth-of-type(15) {
	--animation-index: 15;
}
.booster-open-enter-active.card:nth-of-type(16) {
	--animation-index: 16;
}
.booster-open-enter-active.card:nth-of-type(17) {
	--animation-index: 17;
}
.booster-open-enter-active.card:nth-of-type(18) {
	--animation-index: 18;
}
.booster-open-enter-active.card:nth-of-type(19) {
	--animation-index: 19;
}
.booster-open-enter-active.card:nth-of-type(20) {
	--animation-index: 20;
}

@keyframes booster-card-enter-together {
	0% {
		transform: translate(var(--initial-translation-x), var(--initial-translation-y)) rotate(0) scale(0);
	}
	30% {
		transform: translate(var(--initial-translation-x), var(--initial-translation-y)) rotate(0) scale(1.05);
	}
	90% {
		transform: translate(var(--initial-translation-x), calc(var(--initial-translation-y)))
			rotate(var(--initial-rotation)) scale(1);
	}
	100% {
		transform: translate(var(--initial-translation-x), var(--initial-translation-y)) rotate(var(--initial-rotation));
	}
}

@keyframes booster-card-enter {
	0% {
		transform: translate(var(--initial-translation-x), 0) rotate(var(--initial-rotation));
	}
	35% {
		transform: translate(0, 0);
	}
	75% {
		transform: translate(0, 0);
	}
	100% {
		transform: translate(0, 0);
	}
}

/* This won't work on Firefox right now since it doesn't have :has support yet, but that's ok. It's purely for aesthetic. */
div:has(> .booster-open-enter-active):not(:has(> .booster-open-leave-active))::before {
	content: "";
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 440px;
	height: 440px;
	--beam-color: #ffffff80;
	background-image: repeating-conic-gradient(#ffffffa0 0, #000 18deg, #ffffffa0 36deg);
	background-size: cover;
	background-position: center;
	-webkit-mask: radial-gradient(circle at center, #fff 0%, transparent 70%);
	mask: radial-gradient(circle at center, #fff 0%, transparent 70%);

	opacity: 0;
	transform-origin: center;
	animation: booster-cards-background-animation 0.5s linear forwards;
}

@keyframes booster-cards-background-animation {
	0% {
		transform: translate(-50%, -50%) rotate(0deg) scale(0);
		opacity: 0;
	}
	20% {
		transform: translate(-50%, -50%) rotate(calc(0.2 * 90deg)) scale(1);
		opacity: 1;
	}
	80% {
		opacity: 1;
	}
	100% {
		transform: translate(-50%, -50%) rotate(90deg);
		opacity: 0;
	}
}

.booster-open-enter-active .flip-container {
	animation:
		booster-card-enter-translate calc(var(--translation-duration)) ease
			calc(var(--intro-duration) + var(--enter-delay)) 1,
		booster-card-enter-flip var(--flip-duration) ease-in
			calc(var(--intro-duration) + var(--translation-duration) + var(--enter-delay)) 1;
	animation-fill-mode: none, forwards;

	/* Necessary for the transform origin to be correct */
	width: 100%;
	height: 100%;
	transform: scale(1) translate(0, 0) rotateY(-180deg);
}

@keyframes booster-card-enter-translate {
	0% {
		transform: scale(1) translate(0, var(--initial-translation-y)) rotateY(-180deg);
	}
	100% {
		transform: scale(1) translate(0, 0) rotateY(-180deg);
	}
}

@keyframes booster-card-enter-flip {
	0% {
		transform: scale(1) translate(0, 0) rotateY(-180deg);
	}
	25% {
		transform: scale(1.15) translate(0, 10px) rotateY(-180deg);
	}
	50% {
		transform: scale(1.15) rotateY(-90deg);
	}
	75% {
		transform: scale(1.15) translate(0, -10px) rotateY(0deg);
	}
	100% {
		transform: scale(1) rotateY(0);
	}
}
`, "",{"version":3,"sources":["webpack://./client/src/css/booster-open.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,4BAA4B;CAC5B,qBAAqB;CACrB,6BAA6B;;CAE7B,qBAAqB;CACrB,+EAA+E;;CAE/E;;;qDAGoD;CACpD,uCAAuC;CACvC,6BAA6B;AAC9B;;AAEA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,mGAAmG;CACpG;CACA;EACC,sGAAsG;CACvG;CACA;EACC;2CACyC;CAC1C;CACA;EACC,gHAAgH;CACjH;AACD;;AAEA;CACC;EACC,qFAAqF;CACtF;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,0BAA0B;CAC3B;AACD;;AAEA,2HAA2H;AAC3H;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,oFAAoF;CACpF,sBAAsB;CACtB,2BAA2B;CAC3B,yEAAyE;CACzE,iEAAiE;;CAEjE,UAAU;CACV,wBAAwB;CACxB,kEAAkE;AACnE;;AAEA;CACC;EACC,sDAAsD;EACtD,UAAU;CACX;CACA;EACC,mEAAmE;EACnE,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,8CAA8C;EAC9C,UAAU;CACX;AACD;;AAEA;CACC;;;;mFAIkF;CAClF,mCAAmC;;CAEnC,qDAAqD;CACrD,WAAW;CACX,YAAY;CACZ,oDAAoD;AACrD;;AAEA;CACC;EACC,+EAA+E;CAChF;CACA;EACC,oDAAoD;CACrD;AACD;;AAEA;CACC;EACC,oDAAoD;CACrD;CACA;EACC,0DAA0D;CAC3D;CACA;EACC,sCAAsC;CACvC;CACA;EACC,wDAAwD;CACzD;CACA;EACC,8BAA8B;CAC/B;AACD","sourcesContent":[".booster-open-enter-active.card {\n\t--intro-duration: 0.5s;\n\t--translation-duration: 0.5s;\n\t--flip-duration: 0.4s;\n\t--enter-delay-interval: 0.04s;\n\n\t--animation-index: 20;\n\t--enter-delay: calc((var(--animation-index) - 1) * var(--enter-delay-interval));\n\n\tanimation:\n\t\tbooster-card-enter-together var(--intro-duration) ease 0s 1,\n\t\tbooster-card-enter var(--translation-duration) cubic-bezier(0.34, 0, 0.3, 1)\n\t\t\tcalc(var(--intro-duration) + var(--enter-delay)) 1;\n\tanimation-fill-mode: forwards, forwards;\n\ttransform-origin: center 140%;\n}\n\n.booster-open-enter-active.card:nth-of-type(1) {\n\t--animation-index: 1;\n}\n.booster-open-enter-active.card:nth-of-type(2) {\n\t--animation-index: 2;\n}\n.booster-open-enter-active.card:nth-of-type(3) {\n\t--animation-index: 3;\n}\n.booster-open-enter-active.card:nth-of-type(4) {\n\t--animation-index: 4;\n}\n.booster-open-enter-active.card:nth-of-type(5) {\n\t--animation-index: 5;\n}\n.booster-open-enter-active.card:nth-of-type(6) {\n\t--animation-index: 6;\n}\n.booster-open-enter-active.card:nth-of-type(7) {\n\t--animation-index: 7;\n}\n.booster-open-enter-active.card:nth-of-type(8) {\n\t--animation-index: 8;\n}\n.booster-open-enter-active.card:nth-of-type(9) {\n\t--animation-index: 9;\n}\n.booster-open-enter-active.card:nth-of-type(10) {\n\t--animation-index: 10;\n}\n.booster-open-enter-active.card:nth-of-type(11) {\n\t--animation-index: 11;\n}\n.booster-open-enter-active.card:nth-of-type(12) {\n\t--animation-index: 12;\n}\n.booster-open-enter-active.card:nth-of-type(13) {\n\t--animation-index: 13;\n}\n.booster-open-enter-active.card:nth-of-type(14) {\n\t--animation-index: 14;\n}\n.booster-open-enter-active.card:nth-of-type(15) {\n\t--animation-index: 15;\n}\n.booster-open-enter-active.card:nth-of-type(16) {\n\t--animation-index: 16;\n}\n.booster-open-enter-active.card:nth-of-type(17) {\n\t--animation-index: 17;\n}\n.booster-open-enter-active.card:nth-of-type(18) {\n\t--animation-index: 18;\n}\n.booster-open-enter-active.card:nth-of-type(19) {\n\t--animation-index: 19;\n}\n.booster-open-enter-active.card:nth-of-type(20) {\n\t--animation-index: 20;\n}\n\n@keyframes booster-card-enter-together {\n\t0% {\n\t\ttransform: translate(var(--initial-translation-x), var(--initial-translation-y)) rotate(0) scale(0);\n\t}\n\t30% {\n\t\ttransform: translate(var(--initial-translation-x), var(--initial-translation-y)) rotate(0) scale(1.05);\n\t}\n\t90% {\n\t\ttransform: translate(var(--initial-translation-x), calc(var(--initial-translation-y)))\n\t\t\trotate(var(--initial-rotation)) scale(1);\n\t}\n\t100% {\n\t\ttransform: translate(var(--initial-translation-x), var(--initial-translation-y)) rotate(var(--initial-rotation));\n\t}\n}\n\n@keyframes booster-card-enter {\n\t0% {\n\t\ttransform: translate(var(--initial-translation-x), 0) rotate(var(--initial-rotation));\n\t}\n\t35% {\n\t\ttransform: translate(0, 0);\n\t}\n\t75% {\n\t\ttransform: translate(0, 0);\n\t}\n\t100% {\n\t\ttransform: translate(0, 0);\n\t}\n}\n\n/* This won't work on Firefox right now since it doesn't have :has support yet, but that's ok. It's purely for aesthetic. */\ndiv:has(> .booster-open-enter-active):not(:has(> .booster-open-leave-active))::before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 440px;\n\theight: 440px;\n\t--beam-color: #ffffff80;\n\tbackground-image: repeating-conic-gradient(#ffffffa0 0, #000 18deg, #ffffffa0 36deg);\n\tbackground-size: cover;\n\tbackground-position: center;\n\t-webkit-mask: radial-gradient(circle at center, #fff 0%, transparent 70%);\n\tmask: radial-gradient(circle at center, #fff 0%, transparent 70%);\n\n\topacity: 0;\n\ttransform-origin: center;\n\tanimation: booster-cards-background-animation 0.5s linear forwards;\n}\n\n@keyframes booster-cards-background-animation {\n\t0% {\n\t\ttransform: translate(-50%, -50%) rotate(0deg) scale(0);\n\t\topacity: 0;\n\t}\n\t20% {\n\t\ttransform: translate(-50%, -50%) rotate(calc(0.2 * 90deg)) scale(1);\n\t\topacity: 1;\n\t}\n\t80% {\n\t\topacity: 1;\n\t}\n\t100% {\n\t\ttransform: translate(-50%, -50%) rotate(90deg);\n\t\topacity: 0;\n\t}\n}\n\n.booster-open-enter-active .flip-container {\n\tanimation:\n\t\tbooster-card-enter-translate calc(var(--translation-duration)) ease\n\t\t\tcalc(var(--intro-duration) + var(--enter-delay)) 1,\n\t\tbooster-card-enter-flip var(--flip-duration) ease-in\n\t\t\tcalc(var(--intro-duration) + var(--translation-duration) + var(--enter-delay)) 1;\n\tanimation-fill-mode: none, forwards;\n\n\t/* Necessary for the transform origin to be correct */\n\twidth: 100%;\n\theight: 100%;\n\ttransform: scale(1) translate(0, 0) rotateY(-180deg);\n}\n\n@keyframes booster-card-enter-translate {\n\t0% {\n\t\ttransform: scale(1) translate(0, var(--initial-translation-y)) rotateY(-180deg);\n\t}\n\t100% {\n\t\ttransform: scale(1) translate(0, 0) rotateY(-180deg);\n\t}\n}\n\n@keyframes booster-card-enter-flip {\n\t0% {\n\t\ttransform: scale(1) translate(0, 0) rotateY(-180deg);\n\t}\n\t25% {\n\t\ttransform: scale(1.15) translate(0, 10px) rotateY(-180deg);\n\t}\n\t50% {\n\t\ttransform: scale(1.15) rotateY(-90deg);\n\t}\n\t75% {\n\t\ttransform: scale(1.15) translate(0, -10px) rotateY(0deg);\n\t}\n\t100% {\n\t\ttransform: scale(1) rotateY(0);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
